import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const generalConfig = createAsyncThunk(
  "config/generalConfig",
  async (payload, thunkAPI) => {
    try {
      let url = "general-config";
      const { vpnToken, ...restPayload } = payload || {};

      // If vpnToken is present, add it to the query params
      if (vpnToken) {
        url += `?vpnToken=${encodeURIComponent(vpnToken)}`;
      }
      const response = await api.post(url, restPayload);

      return response.data?.data;
    } catch (error) {
      console.error("❌ generalConfig API Error:", error);
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const generalConfigSlice = createSlice({
  name: "generalConfig",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generalConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generalConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(generalConfig.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch general config";
      });
  },
});

export default generalConfigSlice.reducer;
